export default __webpack_public_path__ + "static/media/enterprise-logo.a7ad78da.png";